// extracted by mini-css-extract-plugin
module.exports = {"avatar":"SquadCatchUpItem_avatar__Ljl72","linkToEmployee":"SquadCatchUpItem_linkToEmployee__ph8e5"};